import { axiosInstance } from './auth';

const API_URL = process.env.REACT_APP_API_URL;

const STRIPE_URL = `${process.env.REACT_APP_API_URL}/stripe/create-checkout-session`;

const getSubscriptionPlans = async (token) => {
  const response = await axiosInstance.get(`${API_URL}/admin/plans/getAll`, {
    headers: { 
      Authorization: `Bearer ${token}`
    },
    
  });
  return response.data;
};

const createPlan = async (token, planData) => {
  const response = await axiosInstance.post(`${API_URL}/admin/plans`, planData, {
    headers: { Authorization: `Bearer ${token}`
  },
  });
  return response.data;
};

const updatePlan = async (token, plan_id, planData) => {
  const response = await axiosInstance.put(`${API_URL}/admin/plans/${plan_id}`, planData, {
    headers: { Authorization: `Bearer ${token}`
  },
    
  });
  return response.data;
};

const deletePlan = async (token, plan_id) => {
  const response = await axiosInstance.delete(`${API_URL}/admin/plans/${plan_id}`, {
    headers: { Authorization: `Bearer ${token}`   },
    
  });
  return response.data;
};

const getUsageStats = async () => {
  const token = localStorage.getItem('token');
  const response = await axiosInstance.get(`${API_URL}/subscription/usage`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

const createSubscription = async (subscriptionData) => {
  const token = localStorage.getItem('token');
  const response = await axiosInstance.post(`${API_URL}/subscription/subscribe`, subscriptionData, {
    headers: { Authorization: `Bearer ${token}`}
  });
  return response.data;
};

const getOneTimePlans = async () => {
  const response = await axiosInstance.get(`${API_URL}/auth/onetime`);
  return response.data;
};

const createCheckoutSession = async (plan_id, token) => {
  const response = await axiosInstance.post(
    STRIPE_URL,
    { plan_id },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

const createCustomCheckoutSession = async (plan_id, included_units, base_price, token) => {
  const response = await axiosInstance.post(
    STRIPE_URL,
    { plan_id, included_units, base_price },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

const fetchClientDetails = async (token) => {
  const response = await axiosInstance.get(`${API_URL}/fetchClientDetails`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

const cancelSubscription = async (token) => {
  const response = await axiosInstance.post(`${API_URL}/stripe/cancel-subscription`, {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

const getBillingSummary = async (token) => {
  const response = await axiosInstance.get(`${API_URL}/billing/summary`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
  });
  return response.data;
};

export const fetchTransactions = async (token, params = {}) => {
  const response = await axiosInstance.get(`${API_URL}/admin/fetchTransactions`, {
    headers: { Authorization: `Bearer ${token}`
  },
    params,
  });
  return response.data;
};

const subscriptionApi = {
  getSubscriptionPlans,
  createPlan,
  updatePlan,
  deletePlan,
  getUsageStats,
  createSubscription,
  getOneTimePlans,
  createCheckoutSession,
  createCustomCheckoutSession,
  fetchClientDetails,
  cancelSubscription,
  getBillingSummary
};

export default subscriptionApi;